import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./card.scss";

import kitchen from "../assets/17kv/04.jpg";
import kitchen_2 from "../assets/Ostrog/1_fl/003.jpg";
import hall_2 from "../assets/Inna/4.jpg";
import bedroom_2 from "../assets/Yula/02.jpg";
import bedroom_3 from "../assets/Georgia/012.jpg";
import bathroom_2 from "../assets/Kobylanska/01.1.jpg";
import studio from "../assets/Genesis/06.jpg";
import exterior from "../assets/resthouse/01.jpg";

import Flat from "../Components/flat";
import FlatTwo from "../Components/flat_2";
import FlatThree from "../Components/flat_3";
import FlatFour from "../Components/flat_4";
import FlatFive from "../Components/flat_5";
import FlatSix from "../Components/flat_6";
import FlatSeven from "../Components/flat_7";
import FlatEight from "../Components/flat_8";
import Inst from "../assets/instagram_logo.png";
import Facebook from "../assets/facebook_logo.png";
import Google from "../assets/google_logo.png";
import { Translation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";

function Portfolio({ isViewerOpen }) {
  const { hash } = useLocation();

  const scrollToTop = () => {
    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (e) {}

    try {
      document.documentElement.scrollTo?.({ top: 0, behavior: "smooth" });
    } catch (e) {}
    try {
      document.body.scrollTo?.({ top: 0, behavior: "smooth" });
    } catch (e) {}

    const findScrollable = (root = document.body) => {
      const all = Array.from(root.querySelectorAll("*"));
      for (const el of all) {
        const cs = getComputedStyle(el);
        const overflowY = cs.overflowY;
        if (
          (overflowY === "auto" || overflowY === "scroll") &&
          el.scrollHeight > el.clientHeight
        ) {
          return el;
        }
      }
      return null;
    };

    const scroller = findScrollable(document);
    if (scroller) {
      try {
        scroller.scrollTo({ top: 0, behavior: "smooth" });
        return;
      } catch (e) {}
    }

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        const offset = 80;
        const top = el.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top,
          behavior: "smooth",
        });
      }
    }
  }, [hash]);

  return (
    <Translation>
      {(t) => (
        <>
          <Helmet>
            <title>
              {t(["seo_portfolio.title"])}
              {/*  AN_DESIGN | Дизайн інтер'єру Україна та Європа, 3D-візуалізація */}
            </title>
            <meta
              name="description"
              content={t([
                "seo_portfolio.description",
              ])} /* "Професійні послуги з дизайну інтер’єру в Україні та Європі. Повний пакет / Пакет лайт / Пакет креслення пакети пакети з 3D-візуалізацією, плануванням меблів та підбором матеріалів." */
            />
            <meta
              name="keywords"
              content={t([
                "seo_portfolio.keywords",
              ])} /* "дизайн інтер'єру, дизайн інтер'єру Київ, дизайн інтер'єру Україна, дизайн інтер'єру Європа, проект інтер'єру, 3D візуалізація, ремонт квартир, дизайн проект будинку, інтер'єр квартири, AN_DESIGN" */
            />
            <link
              rel="canonical"
              href="https://an-design-7e5aa.web.app/portfolio"
            />
            {/* Open Graph for social sharing */}
            <meta property="og:title" content={t(["seo_portfolio.title"])} />
            <meta
              property="og:description"
              content={t(["seo_portfolio.description"])}
            />
            <meta property="og:type" content="website" />
            <meta
              property="og:url"
              content="https://an-design-7e5aa.web.app/portfolio"
            />
            <meta
              property="og:image"
              content="https://an-design-7e5aa.web.app/og-image.png"
            />
          </Helmet>
          <div
            id="portfolio-top"
            style={{
              fontWeight: "bold",
              fontFamily: "Montserrat, sans-serif",
              marginTop: "5em",
              marginBottom: "1em",
              /*  marginLeft: "1em",
              marginRight: "1em", */
              textAlign: "center",
              color: "#46669c",
            }}
          >
            <div>
              {/* Main Portfolio Title */}
              <h1
                className="home-title-big_portfolio"
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  color: "#1c4280",
                  fontSize: "2.1rem",
                  marginBottom: "0.5em",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.5em",
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#46669c"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{
                    width: "0.9em",
                    height: "0.9em",
                    flexShrink: 0,
                  }}
                >
                  <rect x="3" y="3" width="7" height="7"></rect>
                  <rect x="14" y="3" width="7" height="7"></rect>
                  <rect x="14" y="14" width="7" height="7"></rect>
                  <rect x="3" y="14" width="7" height="7"></rect>
                </svg>
                <strong>{t(["portfolio.title"])}</strong>
              </h1>
            </div>

            {/* Subtitle */}
            <h4
              className="mt-3 home-title-small"
              style={{
                fontFamily: "Montserrat, sans-serif",
                fontWeight: "1000",
                color: "#46669c",
                lineHeight: "0.5rem",
              }}
            >
              {t(["home.3D"])} / {t(["home.draw"])}
            </h4>

            <h3
              className="home-title-small"
              style={{
                fontFamily: "Montserrat, sans-serif",
                fontWeight: "400",
                color: "#46669c",
                lineHeight: "1rem",
                marginBottom: "1em",
              }}
            >
              {t(["portfolio.description-23"])}
            </h3>

            <div
              style={{
                marginLeft: "1em",
                marginRight: "1em",
              }}
            >
              <Swiper
                modules={[Navigation]}
                navigation
                spaceBetween={13}
                slidesPerView="auto"
                breakpoints={{
                  320: { slidesPerView: 1 },
                  640: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                  1440: { slidesPerView: 4 },
                }}
                simulateTouch={true}
                allowTouchMove={true}
                slideToClickedSlide={false}
                threshold={10}
                touchStartPreventDefault={false}
                touchMoveStopPropagation={false}
              >
                {[
                  {
                    img: kitchen,
                    desc: t(["portfolio.adres"]),
                    id: "flatOne",
                  },
                  {
                    img: exterior,
                    desc: t(["portfolio.adres-2"]),
                    id: "flatTwo",
                  },
                  {
                    img: hall_2,
                    desc: t(["portfolio.adres-3"]),
                    id: "flatThree",
                  },
                  {
                    img: bedroom_2,
                    desc: t(["portfolio.adres-4"]),
                    id: "flatFour",
                  },
                  {
                    img: bathroom_2,
                    desc: t(["portfolio.adres-5"]),
                    id: "flatFive",
                  },
                  {
                    img: kitchen_2,
                    desc: t(["portfolio.adres-6"]),
                    id: "flatSix",
                  },
                  {
                    img: studio,
                    desc: t(["portfolio.adres-7"]),
                    id: "flatSeven",
                  },
                  {
                    img: bedroom_3,
                    desc: t(["portfolio.adres-8"]),
                    id: "flatEight",
                  },
                ].map((project, index) => (
                  <SwiperSlide
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      const block = document.getElementById(
                        `project-${index + 1}`
                      );
                      if (block) {
                        block.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                      }
                    }}
                  >
                    <div
                      className="portfolio-card"
                      style={{
                        backgroundImage: `url(${project.img})`,
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.05)";
                        e.currentTarget.style.boxShadow =
                          "0 12px 30px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 20px rgba(0,0,0,0.1)";
                      }}
                    >
                      <div className="portfolio-info">
                        <h5 style={{ margin: 0 }}>{project.title}</h5>
                        <p style={{ margin: 0, fontSize: "0.85rem" }}>
                          {project.desc}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div id="project-1" className="scroll-fix-1">
              <Flat />
            </div>

            <div id="project-2" className="scroll-fix">
              <FlatFive />
            </div>

            <div id="project-3" className="scroll-fix">
              <FlatThree />
            </div>

            <div id="project-4" className="scroll-fix">
              <FlatFour />
            </div>

            <div id="project-5" className="scroll-fix">
              <FlatTwo />
            </div>

            <div id="project-6" className="scroll-fix">
              <FlatSix />
            </div>

            <div id="project-7" className="scroll-fix">
              <FlatSeven />
            </div>

            <div id="project-8" className="scroll-fix">
              <FlatEight />
            </div>
          </div>

          {!isViewerOpen && (
            <button id="scrollTopBtn" onClick={scrollToTop}>
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="18 15 12 9 6 15" />
              </svg>
            </button>
          )}

          <div
            style={{
              background: "#4b84c437",
            }}
          >
            <footer className="container py-3">
              <div className="row">
                <div
                  className="col d-flex align-items-center text-muted"
                  style={{
                    fontFamily: "Montserrat, sans-serif",
                    color: "#1c4280",
                  }}
                >
                  2023 AN_DESIGN
                </div>
                <div className="col d-flex align-items-center justify-content-end">
                  <a
                    href="https://www.instagram.com/_an.design_"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={Inst}
                      alt="logo instagram"
                      className="img-fluid"
                      width={30}
                      style={{
                        marginRight: "1em",
                      }}
                    />
                  </a>
                  <a
                    href="https://www.facebook.com/an.design2018/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={Facebook}
                      alt="logo facebook"
                      className="img-fluid"
                      width={30}
                      style={{
                        marginRight: "1em",
                      }}
                    />
                  </a>
                  <a href="mailto:korolskaya.anya@gmail.com">
                    <img
                      src={Google}
                      alt="logo google"
                      className="img-fluid"
                      width={30}
                    />
                  </a>
                </div>
              </div>
            </footer>
          </div>
        </>
      )}
    </Translation>
  );
}

export default Portfolio;
